export const iconFontAwesomeHumanitarianPersonMilitaryToPerson = (
	<i className="fa-solid fa-person-military-to-person"></i>
);
